import type {
    ColorSwatchParseConstantType,
    ColorSwatchLabelConstantType,
    ColorSwatchEdgeConstantType,
    ColorSwatchInkConstantType
} from "./type";
import type {
    ColorVector,
    PickerColor
} from "../../helpers/color";
import {
    getContrastRatio,
    parseColorString,
    formatColorHex,
    compositeOver,
    getColorName,
    rgbToOklch
} from "../../helpers/color";

export const COLOR_SWATCH_EDGE_RATIO = 1.5;

export const COLOR_SWATCH_FALLBACK: PickerColor = {
    alpha: 0,
    rgb: [
        1,
        1,
        1
    ]
};

export const parseColorSwatchColor = ({
    fallback = COLOR_SWATCH_FALLBACK,
    color
}: ColorSwatchParseConstantType): PickerColor => {
    return parseColorString(color) ?? fallback;
};

export const getColorSwatchLabel = ({
    localize,
    color
}: ColorSwatchLabelConstantType): string => {
    const [
        l,
        c,
        h
    ] = rgbToOklch(color.rgb);

    const {
        modifier,
        key
    } = getColorName({
        c: c as number,
        l: l as number,
        h: h as number
    });

    const name = localize(key as keyof NCoreUIKit.Translation);

    const text = modifier ? localize(modifier, [
        name
    ]) : name;

    return `${text}, ${formatColorHex({
        isAlphaEnabled: true,
        alpha: color.alpha,
        rgb: color.rgb
    })}`;
};

export const getColorSwatchVisible = ({
    surface,
    color
}: ColorSwatchEdgeConstantType): ColorVector => {
    return compositeOver({
        foreground: color.rgb,
        background: surface,
        alpha: color.alpha
    });
};

export const getColorSwatchIsEdge = ({
    surface,
    color
}: ColorSwatchEdgeConstantType): boolean => {
    return getContrastRatio(getColorSwatchVisible({
        surface,
        color
    }), surface) < COLOR_SWATCH_EDGE_RATIO;
};

export const getColorSwatchInkIsLight = ({
    background,
    light,
    dark
}: ColorSwatchInkConstantType): boolean => {
    return getContrastRatio(light, background) >= getContrastRatio(dark, background);
};
